
import React from "react";
import { RCCGrid } from "react-common-components";
import { createPortal } from "react-dom";
import { useTranslation } from "src/context/Translations/context";
import ContainerWithoutContext from "src/components/Sortable/ContainerWithoutContext";
import { horizontalListSortingStrategy, verticalListSortingStrategy } from "src/components/Sortable/Container/strategy";
import DragOverlay from "src/components/Sortable/DragOverlay";
import SortableItem from "src/components/Sortable/Item";
import { v4 } from "uuid";
import Title from "src/components/Title";
import { useAuth } from "src/context/Auth/context";
import { PermissionEnum } from "src/context/Auth/interface";
import { ColumnKanban, IColumnsKanban, IKanbanModels, RowKanban } from "../interface";
import { WrapContext } from "../styles";
import DroppableContainer from "../../../components/DroppableContainer";
import PlayingCard from "../../../components/Card";
import Container from "../../../components/Container";

const ColumnsKanban: React.FC<IColumnsKanban> = ({
	activeId,
	disabled,
	containers,
	items,
	columns,
	selectedKanban,
	findContainer,
	onChangeColorColumn,
	onChangeTitleColumn,
	handleAddColumn,
	newItemsContainerName,
	onRemoveColumn,
	placeholderId,
	modalCancelRef,
	modalCommentsRef,
	modalEfficiencyRef,
	modalHistoryRef,
	modalPostponementRef,
	modalProgressRef,
	modalsRef,
	modalsSubactionsRef,
	modalShowPostponementsRef,
	onCallbackUpdateFunction,
	typeKanban
}) => {

	const { translate } = useTranslation();
	const { administrator, superUser, checkIfHasSpecificPermission } = useAuth();

	const isSortingContainer = activeId ? containers.includes(activeId) : false;
  
	const DragOverlayRender = (idActive: string) => {
		if(idActive){
			if(idActive && containers.includes(idActive)){
				 return renderContainerDragOverlay(idActive);
			}

			const container = findContainer(idActive);
			let item;

			if(container)
				item = items[container].find((itemX) => itemX.id === idActive);

			return renderSortableItemDragOverlay(item);
		}
		return null;
	};

	const renderContainerDragOverlay = (containerId: string) => (
		<>
		 {columns && columns[containerId] && (
			 <Container 
			 label={columns[containerId].kba002Descricao}
			 color={columns[containerId].kba002Cor}
			 columns={1}
			 numberOfItems={items[containerId]?.length ?? 0}
		 >
			 {items && items[containerId] && items[containerId].map((item) => (
				 <PlayingCard 
					 key={item.id}
					 value={item}													
				 />
			 ))}
		 </Container>
		 )}
		</>
	);

	const renderSortableItemDragOverlay = (row: RowKanban | undefined) => (
		<PlayingCard 
			key={row?.id}
			value={row || {} as RowKanban} 													
	 />
	);


	return (
		<>
		
			<WrapContext
				hasRelatedTables={typeKanban && typeKanban !== IKanbanModels.ACTIONS}
			>
				<ContainerWithoutContext
					items={[...containers]}
					strategy={horizontalListSortingStrategy}
				>
					<RCCGrid
						container
						item
						direction="row"
						wrap="nowrap"
						style={{ overflowY: "hidden", margin: "0 auto",overflowX: "auto" }}
					>
						{containers.filter((cnt) => cnt !== newItemsContainerName).map((containerId: string) => (
							<DroppableContainer 
								key={containerId}
								idColumn={containerId}
								numberOfItems={items[containerId]?.length ?? 0}
								columnsData={columns[containerId]}
								disabled={disabled ?? false}
								onChangeColorColumn={onChangeColorColumn}
								onChangeTitleColumn={onChangeTitleColumn}
								onRemove={onRemoveColumn}
								permission={selectedKanban?.permission}
							>
								<ContainerWithoutContext items={items[containerId] ?? []} strategy={verticalListSortingStrategy}>
									{items[containerId] && items[containerId].map((valueItem) => (
										<React.Fragment key={v4()}>
											{valueItem && valueItem.id && (
												<SortableItem 
													id={valueItem.id}
													disabled={!(superUser || administrator || (selectedKanban? selectedKanban.permission >= 2 : false) && checkIfHasSpecificPermission("actions/kanban", PermissionEnum.CREATE_UPDATE))}
												>
													<PlayingCard 
														value={valueItem}
														modalCommentsRef={modalCommentsRef}
														modalCancelRef={modalCancelRef}
														modalsSubactionsRef={modalsSubactionsRef}
														modalPostponementRef={modalPostponementRef}
														modalsRef={modalsRef}
														modalEfficiencyRef={modalEfficiencyRef}
														modalProgressRef={modalProgressRef}
														modalShowPostponementsRef={modalShowPostponementsRef}
														onCallbackUpdateFunction={onCallbackUpdateFunction}
														modalHistoryRef={modalHistoryRef} 
														hideSortableHandle={!(superUser || administrator || (selectedKanban? selectedKanban.permission >= 2 : false) && checkIfHasSpecificPermission("actions/kanban", PermissionEnum.CREATE_UPDATE))}													
													/>	
												</SortableItem>
											)}
										</React.Fragment>
									))}
								</ContainerWithoutContext>
							</DroppableContainer>
						))}

						{selectedKanban && ((superUser || administrator || selectedKanban.permission >= 2) && checkIfHasSpecificPermission("actions/kanban", PermissionEnum.CREATE_UPDATE)) && (
							<DroppableContainer
								idColumn={placeholderId}
								disabled={isSortingContainer}
								columnsData={{} as ColumnKanban}
								onClick={handleAddColumn}
								placeholder
							>
								<Title color="purple" size="xs" styleInline="text-align: center;" >
										+ {translate("Clique para adicionar uma coluna")} <br />
									{translate("ou arraste uma ação e solte aqui")} 
								</Title>
							</DroppableContainer>		
						)}
					</RCCGrid>
						
				</ContainerWithoutContext>

				{createPortal(
					<DragOverlay>
						{activeId ? DragOverlayRender(activeId) : null}
					</DragOverlay>,
					document.body
				)}

			</WrapContext>

		</>
	);
};

export default ColumnsKanban;
